import { frontendURL } from '../../../../helper/URLHelper';

const payments = accountId => ({
  parentNav: 'payment',
  routes: [
    'payment-dashboard'
  ],
  menuItems: [
    {
      icon: 'payment',
      key: 'payment',
      label: 'PAYMENT',
      toState: frontendURL(`accounts/${accountId}/payment-dashboard`),
      toStateName: 'payment-dashboard',
    },
  ],
});

export default payments;
